const EMPTY_MESSAGE = "Nog geen bestanden geselecteerd.";

const uploadIconSvg = `<svg class="freeform-file-upload__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>`;

function renderFileList(container, names) {
  container.textContent = names.length
    ? names.join(", ")
    : EMPTY_MESSAGE;
}

function enhanceFileField(container) {
  if (container.dataset.freeformFileEnhanced === "true") {
    return;
  }
  const input = container.querySelector('input[type="file"]');
  if (!input || container.classList.contains("freeform-fieldtype-file-dnd")) {
    return;
  }

  container.dataset.freeformFileEnhanced = "true";
  input.classList.add("freeform-file-upload__input");

  const box = document.createElement("div");
  box.className = "freeform-file-upload";

  const inner = document.createElement("div");
  inner.className = "freeform-file-upload__inner";

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "freeform-file-upload__btn";
  btn.innerHTML = `${uploadIconSvg}<span class="freeform-file-upload__btn-label">Kies bestand(en)</span>`;

  const status = document.createElement("div");
  status.className = "freeform-file-upload__status";
  status.setAttribute("role", "status");
  status.setAttribute("aria-live", "polite");
  renderFileList(status, []);

  input.parentNode.insertBefore(box, input);
  box.appendChild(input);
  inner.appendChild(btn);
  inner.appendChild(status);
  box.appendChild(inner);

  const syncFromInput = () => {
    const files = input.files;
    const names = files && files.length ? Array.from(files, (f) => f.name) : [];
    renderFileList(status, names);
  };

  btn.addEventListener("click", () => input.click());

  input.addEventListener("change", syncFromInput);

  const form = input.closest("form");
  if (form) {
    form.addEventListener("reset", () => {
      queueMicrotask(syncFromInput);
    });
  }
}

export default function prepareFreeformFileUpload() {
  document
    .querySelectorAll(
      ".freeform-fieldtype-file:not(.freeform-fieldtype-file-dnd)"
    )
    .forEach((el) => enhanceFileField(el));
}
